import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ScoreInfo } from "../../common/Info";
import { startGame } from "./gameSlice";

const initialState: { highScores: ScoreInfo[]; lowScores: ScoreInfo[] } = {
  highScores: [],
  lowScores: [],
};

const historicLeaderboardSlice = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {
    setHighScores(state, action: PayloadAction<ScoreInfo[]>) {
      state.highScores = action.payload;
    },
    setLowScores(state, action: PayloadAction<ScoreInfo[]>) {
      state.lowScores = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(startGame, () => {
      return initialState;
    });
  },
});

export const { setHighScores, setLowScores } = historicLeaderboardSlice.actions;
export const historicLeaderboardReducer = historicLeaderboardSlice.reducer;
